<app-header></app-header>
<div class="container">
    <div class="row">
        <div class="col">
            <h1>Login</h1>
            <p class="small-content">
                You must be logged in to view results for
                <i *ngIf="assignmentName">{{ assignmentName }}</i>
                <ng-container *ngIf="!assignmentName"
                    >your assignment</ng-container
                >
            </p>
            <div class="login" *ngIf="!userService.hasStudentExperience()">
                <app-register
                    [showSocialIcons]="true"
                    [nextURL]="nextURL"
                    text="Teacher Login"
                >
                </app-register>
            </div>
            <span
                class="login-separator"
                *ngIf="!userService.hasStudentExperience()"
                >or</span
            >
            <div class="login">
                <app-register
                    [showSocialIcons]="true"
                    [nextURL]="nextURL"
                    [student]="true"
                    text="Student Login"
                >
                </app-register>
            </div>
        </div>
        <div class="col">
            <img class="error-img" [src]="imageURL" />
        </div>
    </div>
</div>
<app-footer></app-footer>
<app-simplified-footer></app-simplified-footer>
